import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Legend
} from 'recharts';

const money = (v) => Number(v || 0).toLocaleString('es-PE', { style: 'currency', currency: 'PEN' });

function ChartTooltip({ active, payload, label }) {
  if (!active || !payload?.length) return null;

  return (
    <div className="rounded-2xl border border-gray-100 bg-white px-3 py-2 text-xs shadow-lg">
      <div className="text-gray-500">{label}</div>
      {payload.map((item) => (
        <div key={item.dataKey} className="mt-1 flex items-center gap-2 text-sm font-semibold text-gray-900">
          <span className="inline-block h-2 w-2 rounded-full" style={{ backgroundColor: item.color }} />
          {item.name}: {money(item.value)}
        </div>
      ))}
    </div>
  );
}

export default function RentaBarChart({ data = [], title = 'Amortización y Renta', loading = false }) {
  if (loading) {
    return (
      <div className="h-full">
        <h3 className="text-base font-semibold text-gray-900 mb-2">{title}</h3>
        <div className="h-[340px] flex items-center justify-center">
          <div className="text-gray-400">Cargando gráfico...</div>
        </div>
      </div>
    );
  }

  if (data.length === 0) {
    return (
      <div className="h-full">
        <h3 className="text-base font-semibold text-gray-900 mb-2">{title}</h3>
        <div className="h-[340px] flex items-center justify-center">
          <div className="text-gray-400">Sin datos para mostrar</div>
        </div>
      </div>
    );
  }

  return (
    <div className="h-full">
      <div className="mb-4 flex items-center justify-between">
        <div>
          <h3 className="text-base font-semibold text-gray-900">{title}</h3>
          <p className="text-xs text-gray-500">Comparativo por asesor</p>
        </div>
      </div>

      <div className="h-[320px] overflow-visible">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={data}
            margin={{ top: 12, right: 16, left: 8, bottom: 60 }}
          >
            <defs>
              <linearGradient id="rentaAmortizacion" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#fbbf24" stopOpacity={0.95} />
                <stop offset="100%" stopColor="#f59e0b" stopOpacity={0.7} />
              </linearGradient>
              <linearGradient id="rentaRenta" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#ef4444" stopOpacity={0.95} />
                <stop offset="100%" stopColor="#dc2626" stopOpacity={0.7} />
              </linearGradient>
            </defs>
            <CartesianGrid stroke="#e2e8f0" strokeDasharray="4 4" vertical={false} />
            <XAxis
              dataKey="asesor"
              tick={{ fontSize: 11, width: 80, wordBreak: 'break-word', fill: '#6b7280' }}
              textAnchor="middle"
              interval={0}
            />
            <YAxis
              tickFormatter={(v) => money(v)}
              tick={{ fontSize: 11, fill: '#6b7280' }}
            />
            <Tooltip content={<ChartTooltip />} />
            <Legend
              wrapperStyle={{ fontSize: 12 }}
              iconType="rect"
              verticalAlign="top"
              align="center"
              height={36}
            />
            <Bar
              dataKey="amortizacion"
              fill="url(#rentaAmortizacion)"
              name="Amortización"
              radius={[6, 6, 0, 0]}
              barSize={18}
            />
            <Bar
              dataKey="renta"
              fill="url(#rentaRenta)"
              name="Renta"
              radius={[6, 6, 0, 0]}
              barSize={18}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
